import { createSlice } from "@reduxjs/toolkit";
import { resetStateThunk } from "redux/Thunks/Authentication";
import { getProjectMapQhseData } from "redux/Thunks/ProjectMap";
import Constants from "utils/Constants";

const initialState = {
  loading: Constants.PENDING,
  qhseList: [],
  screens: [],
};

export const safetyCardSlice = createSlice({
  name: "projectmap",
  initialState,
  reducers: {
    resetQHSE(state) {
      state.qhseList = [];
    },
  },

  extraReducers: {
    [getProjectMapQhseData.pending]: (state) => {
      if (state.qhseList.length === 0) state.loading = Constants.PENDING;
    },
    [getProjectMapQhseData.fulfilled]: (state, action) => {
      state.loading = Constants.FULFILLED;
      state.qhseList = action.payload.data.qhseData;
    },
    [getProjectMapQhseData.rejected]: (state) => {
      state.loading = Constants.REJECTED;
    },
    [resetStateThunk.fulfilled]: (state) => {
      state.loading = Constants.IDLE;
      state.qhseList = [];
      state.screens = [];
    },
  },
});

export const { resetQHSE } = safetyCardSlice.actions;

export default safetyCardSlice.reducer;
